import Environment from '@di-shared/features/environment/Environment';
import Kr from '@di-shared/features/history/driving-info/DrivingInfoEcoMileageBanner/.kr';

export interface DrivingInfoEcoMileageBannerProps {
  vin: string;
  averageDistance: number;
}

export default function DrivingInfoEcoMileageBanner({vin, averageDistance}: DrivingInfoEcoMileageBannerProps) {
  return (
    <>
      <Environment.Kr>
        <Kr
          vin={vin}
          averageDistance={averageDistance}
        />
      </Environment.Kr>
    </>
  );
}
